"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypeSerializer_1 = require("@ulixee/commons/lib/TypeSerializer");
class Client {
    constructor() {
        this.pendingMessagesById = new Map();
        this.messageCounter = 0;
        this.eventHandlersByEventType = {};
        this.lastEventByEventType = {};
    }
    connect() {
        if (this.connectedPromise) {
            return this.connectedPromise;
        }
        if (!window.minerAddress) {
            return Promise.resolve();
        }
        this.connection = new WebSocket(window.minerAddress);
        this.connection.onclose = this.onClose.bind(this);
        this.connectedPromise = new Promise(resolve => {
            this.connection.onopen = () => resolve();
        });
        this.connection.onmessage = this.emit.bind(this);
        return this.connectedPromise.then(this.onConnect);
    }
    on(event, handler) {
        this.eventHandlersByEventType[event] ??= [];
        this.eventHandlersByEventType[event].push(handler);
        const lastEvent = this.lastEventByEventType[event];
        if (lastEvent)
            handler(lastEvent);
    }
    off(event, handler) {
        const handlers = this.eventHandlersByEventType[event];
        if (!handlers)
            return;
        const idx = handlers.indexOf(handler);
        if (idx >= 0)
            handlers.splice(idx, 1);
    }
    onClose() {
        this.connectedPromise = null;
        setTimeout(() => {
            this.connect().catch(err => console.log('Client Connect Error', err));
        }, 1e3);
    }
    async send(command, ...args) {
        if (!this.connectedPromise) {
            setTimeout(() => this.send(command, ...args), 500);
            return;
        }
        await this.connectedPromise;
        this.messageCounter += 1;
        const messageId = String(this.messageCounter);
        const message = TypeSerializer_1.default.stringify({
            command,
            messageId,
            args,
        });
        document.dispatchEvent(new CustomEvent('chromealive:api', {
            detail: { command, messageId, args },
        }));
        return new Promise(resolve => {
            this.connection.send(message);
            this.pendingMessagesById.set(messageId, { resolve });
        });
    }
    emit(message) {
        const event = TypeSerializer_1.default.parse(message.data);
        if ('eventType' in event) {
            this.lastEventByEventType[event.eventType] = event.data;
            for (const handler of this.eventHandlersByEventType[event.eventType] ?? []) {
                handler(event.data);
            }
            document.dispatchEvent(new CustomEvent('chromealive:event', {
                detail: event,
            }));
        }
        else {
            const { responseId, data } = event;
            this.pendingMessagesById.get(responseId)?.resolve(data);
            this.pendingMessagesById.delete(responseId);
        }
    }
}
window.minerAddress = process.env.VUE_APP_BASE_URI ?? '';
// eslint-disable-next-line import/no-mutable-exports
let defaultClient;
if (window.opener) {
    defaultClient = window.opener.defaultClient;
}
else {
    defaultClient = new Client();
}
window.setMinerAddress = function setMinerAddress(url) {
    window.minerAddress = url;
    defaultClient.connect().catch(console.error);
};
// if already set, connect now
if (window.minerAddress) {
    defaultClient.connect().catch(console.error);
}
window.defaultClient = defaultClient;
exports.default = defaultClient;
